import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { CheckoutConditionsPage } from '@/areas/settings/manufacturing/OrganizationSettings/CheckoutConditions';
import { canViewCustomerPortalSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/_menu/organization/customer-portal/checkout-conditions')(
    {
        staticData: {
            access: { permissions: canViewCustomerPortalSettings },
            chrome: 'home',
        } satisfies PageStaticData,
        component: RouteComponent,
    },
);

function RouteComponent(): JSX.Element {
    return <CheckoutConditionsPage />;
}
